import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var PaymentLogoVisa = _ref => {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoVisa',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 33,
    height: 22,
    fill: "none",
    viewBox: "0 0 33 22"
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M0 0h33v22H0z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1434CB",
    d: "m12.89 6.171-3.927 9.371H6.4L4.468 8.064c-.118-.46-.22-.63-.577-.824-.582-.316-1.544-.612-2.391-.796l.058-.273h4.124c.526 0 .999.35 1.118.956l1.02 5.422 2.524-6.378h2.546Zm10.04 6.312c.011-2.474-3.42-2.61-3.395-3.715.007-.336.327-.693 1.028-.785.347-.045 1.304-.08 2.39.42l.425-1.988A6.514 6.514 0 0 0 21.111 6c-2.396 0-4.082 1.274-4.097 3.098-.015 1.349 1.204 2.101 2.122 2.55.945.459 1.262.754 1.259 1.164-.007.629-.754.907-1.452.917-1.218.02-1.925-.33-2.489-.591l-.44 2.053c.567.26 1.613.486 2.696.498 2.547 0 4.213-1.258 4.22-3.206Zm6.328 3.06H31.5L29.543 6.17h-2.07a1.1 1.1 0 0 0-1.03.688l-3.639 8.683h2.546l.505-1.4h3.11l.293 1.4Zm-2.705-3.321 1.276-3.519.735 3.519h-2.01Zm-10.199-6.05-2.004 9.37h-2.424l2.005-9.37h2.423Z"
  }));
};
PaymentLogoVisa.displayName = 'PaymentLogoVisa';
export default withProvisionalOverrideFromContext(PaymentLogoVisa);
//# sourceMappingURL=index.js.map